import type { FC } from 'react';

import { SwipableBox } from '@eneco/custom-components/SwipableBox/SwipableBox';
import { useLinkComponent } from '@eneco/link';
import { Bleed, TabNavigation as SparkyTabNavigation, PageGrid } from '@eneco/sparky';
import { wrap } from '@sitecore/common';
import { TabNavigationRendering } from '@sitecore/types/manual/TabNavigation';

const TabNavigation: FC<TabNavigationRendering> = ({ fields }) => {
  const { items, ariaLabel } = fields;
  const Link = useLinkComponent();
  return (
    <PageGrid>
      <PageGrid.Item gridColumn="1/-1">
        <Bleed horizontal={{ initial: 'gridGutter', lg: '0' }}>
          <SwipableBox>
            <SparkyTabNavigation ariaLabel={wrap(ariaLabel)}>
              {items?.map((item, i) => (
                <Link
                  key={item.id}
                  editable={item.fields.link.editable}
                  linkType={item.fields.link.value.linktype}
                  linkValue={item.fields.link.value}>
                  <SparkyTabNavigation.Item>{item.fields.link.value.text}</SparkyTabNavigation.Item>
                </Link>
              ))}
            </SparkyTabNavigation>
          </SwipableBox>
        </Bleed>
      </PageGrid.Item>
    </PageGrid>
  );
};

export { TabNavigation };
export default TabNavigation;
